module.exports = __webpack_public_path__ + "img/box1-b.bdada66b.png";